import { useState } from "react";
import { getAttachmentById } from "../calls/apiCalls";
import { useSnackbar } from "../contexts/SnackbarContext";
import useScreenDimensions from "./useScreenDimensions";

const useFiles = () => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [imageId, setImageId] = useState(null);
  const [loadingImage, setLoadingImage] = useState(false);
  const { isMobile } = useScreenDimensions();
  const { showSnackbar } = useSnackbar();

  const openFile = async (fileId, url, download = true) => {
    setLoadingImage(true);
    var isSafari = window.safari !== undefined;

    try {
      const message = await getAttachmentById(fileId, url, async (data) => {
        const mimetype = data.fileName.split(".");
        if (mimetype.length < 2) {
          const base64type = data.base64String.substr(0, 3);
          if (base64type === "/9j") {
            mimetype.push("jpg");
          }
          if (base64type === "iVB") {
            mimetype.push("png");
          }
          if (base64type === "Qk0") {
            mimetype.push("bmp");
          }
          if (base64type === "SUk") {
            mimetype.push("tiff");
          }
          if (base64type === "JVB") {
            mimetype.push("pdf");
          }
          if (base64type === "UEs") {
            mimetype.push("ofd");
          }
        }
        const fileType = mimetype[mimetype.length - 1].toLowerCase();
        let isImage = false;
        try {
          if (fileType === "xlsx" || fileType === "xls") {
            var type = "application/vnd.ms-excel";
          } else if (fileType === "doc" || fileType === "docx") {
            type = "application/msword";
          } else if (
            fileType === "tiff" ||
            fileType === "jpeg" ||
            fileType === "jpe" ||
            fileType === "png" ||
            fileType === "jpg" ||
            (fileType === "pdf" && (isSafari || isMobile)) ||
            (fileType === "jpg" && (isSafari || isMobile)) ||
            (fileType === "png" && (isSafari || isMobile))
          ) {
            type = "image/" + fileType;
            isImage = true;
          } else if (fileType === "zip") {
            type = "multipart/x-zip";
          } else type = "application/" + fileType;

          const blob = fileConversion(data.base64String, type);
          const fileurl = URL.createObjectURL(blob);
          if (!download && (isImage || fileType === "pdf")) {
            setBlobUrl({
              url: fileurl,
              mimetype: mimetype[0],
              fileType: fileType,
            });
            return true;
          }
          if (
            true ||
            fileType === "xlsx" ||
            fileType === "xls" ||
            fileType === "doc" ||
            fileType === "docx" ||
            fileType === "zip"
          ) {
            var downloadLink = document.createElement("a");
            downloadLink.href = fileurl;
            downloadLink.download = `${mimetype[0]}.${fileType}`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
          } else {
            var strWindowFeatures = "location=yes,scrollbars=yes,status=yes";
            const pdfWindow = window.open(fileurl, `_blank`, strWindowFeatures);
            pdfWindow.URL.revokeObjectURL(fileurl);
          }
          window.URL.revokeObjectURL(fileurl);
        } catch (error) {
          console.error(error);
        }
      });
      if (message) showSnackbar(message);
    } catch (error) {
      console.error("Error acquiring", error);
      showSnackbar("Could not open this file.");
    }
    setLoadingImage(false);
  };

  const downloadImageBlob = (fileurl) => {
    var downloadLink = document.createElement("a");
    downloadLink.href = fileurl.url;
    downloadLink.download = `${fileurl.mimetype}.${fileurl.fileType}`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
  };

  const getImageUrl = async (fileId, url) => {
    if (!fileId) {
      setBlobUrl("");
      return;
    } else if (imageId === fileId) {
      return;
    } else {
      setImageId(fileId);
    }

    setLoadingImage(true);
    var isSafari = window.safari !== undefined;

    try {
      const message = await getAttachmentById(fileId, url, async (data) => {
        const mimetype = data.fileName.split(".");
        if (mimetype.length < 2) {
          const base64type = data.base64String.substr(0, 3);
          if (base64type === "/9j") {
            mimetype.push("jpg");
          }
          if (base64type === "iVB") {
            mimetype.push("png");
          }
          if (base64type === "Qk0") {
            mimetype.push("bmp");
          }
          if (base64type === "SUk") {
            mimetype.push("tiff");
          }
          if (base64type === "JVB") {
            mimetype.push("pdf");
          }
          if (base64type === "UEs") {
            mimetype.push("ofd");
          }
        }
        const fileType = mimetype[mimetype.length - 1].toLowerCase();
        try {
          if (fileType === "xlsx" || fileType === "xls") {
            var type = "application/vnd.ms-excel";
          } else if (fileType === "doc" || fileType === "docx") {
            type = "application/msword";
          } else if (
            fileType === "tiff" ||
            fileType === "jpeg" ||
            fileType === "jpe" ||
            fileType === "png" ||
            fileType === "jpg" ||
            (fileType === "pdf" && (isSafari || isMobile)) ||
            (fileType === "jpg" && (isSafari || isMobile)) ||
            (fileType === "png" && (isSafari || isMobile))
          ) {
            type = "image/" + fileType;
          } else if (fileType === "zip") {
            type = "multipart/x-zip";
          } else type = "application/" + fileType;

          const blob = fileConversion(data.base64String, type);
          const fileurl = URL.createObjectURL(blob);

          setBlobUrl(fileurl);
          return fileurl;
        } catch (error) {
          console.error(error);
        }
      });
      if (message) showSnackbar(message);
    } catch (error) {
      console.error("Error acquiring", error);
      showSnackbar("Could not open this file.");
    }
    setLoadingImage(false);
  };

  function fileConversion(base64Data, contentType) {
    contentType = contentType || "";
    var sliceSize = 512;
    base64Data = base64Data.replace(/^[^,]+,/, "");
    base64Data = base64Data.replace(/\s/g, "");
    var byteCharacters = window.atob(base64Data);
    var byteArrays = [];
    for (
      var offset = 0;
      offset < byteCharacters?.length;
      offset = offset + sliceSize
    ) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice?.length);
      for (var i = 0; i < slice?.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  return {
    blobUrl,
    loadingImage,
    openFile,
    setBlobUrl,
    getImageUrl,
    setLoadingImage,
    downloadImageBlob,
  };
};

export default useFiles;
